import styles from "./Service.module.css";

const mbcardapioFeatures = [
  "Cardapio digital com fotos de cada prato",
  "Acesso pelo celular via leitura de QR Code na mesa",
  "Pedido feito direto pelo cliente, sem precisar instalar app",
  "Cardapio 100% configuravel pela sua equipe",
];

const mbcontrolModules = [
  "PDV com Leitor de Codigo de Barras",
  "Pedidos de Venda e Faturamento",
  "Controle de Estoque",
  "Financeiro (Contas a Pagar/Receber)",
  "Fluxo de Caixa",
  "Emissao de NFe",
  "Producao (PCP, BOM, MRP)",
  "Ordens de Producao",
  "Compras e Cotacoes",
  "Ordens de Servico",
  "Comissoes de Vendas",
  "Relatorios e Dashboards",
  "Impressao de Etiquetas",
  "Multi-empresa e Multi-usuario",
  "Controle de Acesso",
  "Conformidade LGPD",
];

export default function Services() {
  return (
    <section className={styles.services} id="produtos">
      <h2 className={styles.sectionTitle}>Nossos Produtos</h2>
      <p className={styles.sectionSubtitle}>
        Solucoes completas para a gestao do seu negocio
      </p>

      <div className={styles.grid}>
        <div className={`${styles.card} ${styles.cardMain}`}>
          <div className={styles.cardHeader}>
            <span className={styles.cardBadge}>Principal</span>
            <h3>MBControl ERP</h3>
            <p className={styles.cardDescription}>
              Sistema ERP completo e 100% web para gestao integrada da sua
              empresa. Do chao de fabrica ao financeiro, tudo em uma unica
              plataforma moderna e acessivel de qualquer dispositivo.
            </p>
          </div>

          <div className={styles.modules}>
            {mbcontrolModules.map((mod, index) => (
              <span key={index} className={styles.moduleBadge}>
                {mod}
              </span>
            ))}
          </div>

          <a
            href="https://wa.me/5517991254844?text=Ol%C3%A1,%20vim%20pelo%20site%20e%20quero%20conhecer%20o%20MBControl"
            target="_blank"
            rel="noreferrer"
            className={styles.cardButton}
          >
            Solicitar Demonstracao
          </a>
        </div>

        <div className={styles.secondaryGrid}>
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <span className={styles.cardBadgeNew}>Novo</span>
              <h3>MBCardapio</h3>
              <p className={styles.cardDescription}>
                Cardapio digital para restaurantes, bares, conveniencias e
                lanchonetes. O cliente escaneia o QR Code na mesa, ve o
                cardapio com fotos e faz o pedido direto pelo celular.
              </p>
            </div>

            <ul className={styles.featureList}>
              {mbcardapioFeatures.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>

            <a
              href="https://wa.me/5517991254844?text=Ol%C3%A1,%20vim%20pelo%20site%20e%20quero%20conhecer%20o%20MBCard%C3%A1pio"
              target="_blank"
              rel="noreferrer"
              className={styles.cardButtonCardapio}
            >
              Conhecer o MBCardapio
            </a>
          </div>

          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <span className={styles.cardBadgeSec}>Sob Medida</span>
              <h3>Solucoes Personalizadas</h3>
              <p className={styles.cardDescription}>
                Desenvolvemos sistemas e integracoes sob medida para o seu
                negocio. APIs, dashboards, automacoes, aplicativos e
                plataformas web com tecnologia de ponta.
              </p>
            </div>

            <ul className={styles.featureList}>
              <li>Integracao com sistemas existentes</li>
              <li>Aplicativos e plataformas web</li>
              <li>Automacao de processos</li>
              <li>APIs e webhooks</li>
              <li>Dashboards e relatorios</li>
            </ul>

            <a
              href="https://wa.me/5517991254844?text=Ol%C3%A1,%20vim%20pelo%20site%20e%20quero%20saber%20sobre%20desenvolvimento%20personalizado"
              target="_blank"
              rel="noreferrer"
              className={styles.cardButtonOutline}
            >
              Entre em Contato
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
